import React from 'react';
import NodeEditorAction from '../components/NodeEditorAction';
import { PanoramaVFTPortalConfig } from '../models/PanoramaVFTConfig';
import SelectDropdown from '../components/SelectDropdown';

type PanoramaVFTPortalEditorProps = {
    portal: PanoramaVFTPortalConfig,
    nodeKey: number,
    availablePortals: Map<string, string>,
    availableScenes: Map<string, string>,
    updatePortal: (p: PanoramaVFTPortalConfig, key: number) => void,
    onChevronUp: (key: number) => void,
    onChevronDown: (key: number) => void,
    onDelete: (key: number) => void,
};

const PanoramaVFTPortalEditor = ({
    portal,
    nodeKey,
    availablePortals,
    availableScenes,
    updatePortal,
    onChevronUp,
    onChevronDown,
    onDelete }: PanoramaVFTPortalEditorProps) => {

    const labelClasses = "block text-left tracking-wide text-gray-700 text-xs font-bold mb-2";
    const inputClasses = "appearance-none block w-full text-gray-700 border border-gray-200 rounded py-2 px-4 leading-tight focus:outline-none focus:bg-white focus:border-gray-500";

    const onNameChange = (newName: string) => {
        portal.eventName = newName;
        updatePortal(portal, nodeKey);
    }

    const onDegreeChange = (e: React.FormEvent<HTMLInputElement>) => {
        portal.degree = Number(e.currentTarget.value);
        updatePortal(portal, nodeKey);
    }

    const onTargetChange = (scene: string) => {
        portal.target = scene;
        updatePortal(portal, nodeKey);
    }

    return (
        <div className='mb-3 border rounded-lg shadow'>
            <div className="px-2 my-2 flex flex-wrap">
                <div className="flex-1 px-3">
                    <div className='mb-4'>
                        <label className={labelClasses}>Unique ID</label>
                        <SelectDropdown
                            value={portal.eventName}
                            options={availablePortals}
                            onSelectChange={onNameChange} />
                    </div>
                    <div className='mb-4'>
                        <label className={labelClasses}>Target scene</label>
                        <SelectDropdown
                            value={portal.target}
                            options={availableScenes}
                            onSelectChange={onTargetChange} />
                    </div>
                    <div className='mb-4'>
                        <label className={labelClasses}>Initial degree</label>
                        <input className={inputClasses} type="number" placeholder="Enter the initial degree" value={portal.degree} onChange={onDegreeChange} />
                    </div>
                </div>

                <NodeEditorAction nodeKey={nodeKey} onChevronUp={onChevronUp} onChevronDown={onChevronDown} onDelete={onDelete} />
            </div>
        </div>
    )
}

export default PanoramaVFTPortalEditor;

